export default __webpack_public_path__ + "static/char-thumb-43-9ddf88273478ad25d0cb239fde366209.png";